import { useCallback, useEffect, useState } from 'react';

/**
 * @param {(token: string) => Promise<any[]>} fetcher
 * @param {string | null} token
 */
export function useCareList(fetcher, token) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(Boolean(token));
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!token) {
      setData([]);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const rows = await fetcher(token);
      setData(Array.isArray(rows) ? rows : []);
    } catch (e) {
      setError(e instanceof Error ? e : new Error('Failed to load data'));
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [fetcher, token]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
